export type LeadPayload = {
  name: string;
  contact: string;
  grade: string;
};

export async function postLead(payload: LeadPayload): Promise<{ ok: true } | { ok: false; error: string }> {
  try {
    const r = await fetch('/api/leads', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (r.ok) return { ok: true };
    const body = (await r.json().catch(() => ({}))) as { error?: string };
    return { ok: false, error: body.error ?? 'server_error' };
  } catch {
    return { ok: false, error: 'network_error' };
  }
}
